import * as actions from './actions';
import HeaderApi from '../../../../services/HeaderApi';

export const getPostSaleDetails = dispatch => {
  dispatch(actions.getPostSaleDetailsBegin());
  return HeaderApi.fetchHeaderWithAuthV2('postsale/details')
    .then(response => {
      dispatch(actions.getPostSaleDetailsSuccess(response));
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error);
      dispatch(actions.getPostSaleDetailsFailure(error));
    });
};
